<div class="navbar navbar-dark">
  <ul class="navbar-nav">
    <li class="dropdown" ngbDropdown>
      <a class="dropdown-toggle" role="button" id="user-settings" ngbDropdownToggle>
        <pcs-icon icon="person_outline" size="iconM"></pcs-icon>
        {{user}}
      </a>
      <ul ngbDropdownMenu aria-labelledby="user-settings">
        <li>
          <a [routerLink]="['settings']" ngbDropdownItem>
            <pcs-icon icon="settings" size="iconM"></pcs-icon>
            {{'headertab.userinfo' | translate}}
          </a>
        </li>
        <li>
          <a [routerLink]="['agencies-and-users']" ngbDropdownItem>
            <pcs-icon icon="group" size="iconM"></pcs-icon>
            {{'header.agenciesAndUsers' | translate}}
          </a>
        </li>
        <li>
          <a [routerLink]="['timetable-periods']" ngbDropdownItem>
            <pcs-icon icon="today" size="iconM"></pcs-icon>
            {{'navigation.timetablePeriods' | translate}}
          </a>
        </li>
        <li>
          <a [routerLink]="['promotions', ttp.id]" ngbDropdownItem>
            <pcs-icon icon="timeline" size="iconM"></pcs-icon>
            {{'promotions.title' | translate}}
          </a>
        </li>
        <li>
          <a (click)="logout.emit()" ngbDropdownItem>
            <pcs-icon icon="exit_to_app" size="iconM"></pcs-icon>
            {{'header.logOut' | translate}}
          </a>
        </li>
      </ul>
    </li>
  </ul>
</div>
